import { render } from "./Start.vue?vue&type=template&id=207c01b6"
import script from "./Start.vue?vue&type=script&setup=true&lang=js"
export * from "./Start.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/exhishare/Start.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "207c01b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('207c01b6', __exports__)) {
    api.reload('207c01b6', __exports__)
  }
  
  module.hot.accept("./Start.vue?vue&type=template&id=207c01b6", () => {
    api.rerender('207c01b6', render)
  })

}


export default __exports__